// Same-origin defaults. The API is on the same host as these screens, under
// the app's own path: window.location.origin + '/hiring/api' (APP_BASE is
// '/hiring' there; '' when served at the root, e.g. local dev). The old
// hardcoded legacy-domain fallbacks have been removed so a misconfigured .env
// can never silently send prod traffic to the wrong host.
import { APP_BASE, API_ROOT } from './base';

const origin = typeof window !== 'undefined' ? window.location.origin : '';

const config = {
  aiApiUrl: process.env.REACT_APP_AI_URL  || `${origin}${API_ROOT}/api`,
  apiUrl:   process.env.REACT_APP_API_URL || `${origin}${API_ROOT}/api`,
  // Where these screens live — the base of every link sent to a candidate.
  baseUrl:  (origin && `${origin}${APP_BASE}`) || process.env.REACT_APP_BASE_URL || '',
};

export default config;
